import React from "react"

import {
  FormOverlay,
  HookFormOverlayProps
} from "shared/ui/overlay/FormOverlay"

import { FloorFormModel } from "features/floor-management/types/FloorFormModel"
import { FloorFormTabType } from "features/floor-management/types/FloorFormTabType"
import { FloorForm } from "widgets/floor/floor-form/FloorForm"

import "./styles/_floor-overlay.scss"

export interface FloorOverlayModel extends Omit<HookFormOverlayProps, "form"> {
  formID: string
  floorFormModel: FloorFormModel
  defaultTab?: FloorFormTabType
  autoFocus?: boolean
  isSubmitting?: boolean
}

export const FloorOverlay = React.memo(
  ({
    id,
    formID,
    headline,
    prefix,
    floorFormModel,
    defaultTab,
    autoFocus,
    submitButtonText,
    isLoading,
    isSubmitting,
    onCancel
  }: FloorOverlayModel) => {
    const {
      isLoadingRoomOptions,
      isLoadingPositionOptions,
      isLoadingProjectOptions
    } = floorFormModel

    const optionsLoading =
      isLoadingRoomOptions ||
      isLoadingPositionOptions ||
      isLoadingProjectOptions

    return (
      <FormOverlay
        id={id}
        form={formID}
        headline={headline}
        prefix={prefix}
        submitButtonText={submitButtonText}
        onCancel={onCancel}
        isLoading={optionsLoading || isLoading}
        isSubmitDisabled={isLoading}
        isDisabled={isSubmitting}
        showCloseButton
        className="floor-overlay"
      >
        <FloorForm
          id={formID}
          autoFocus={autoFocus}
          {...floorFormModel}
          // Must come after the spread: if FloorFormModel ever gains isDisabled,
          // the overlay's in-flight signal must win over anything the model carries.
          isDisabled={isSubmitting}
        >
          <FloorForm.ProjectInput />
          <FloorForm.LabelInput />
          <FloorForm.PositionInput />
          {/* <FloorForm.RoomAssignmentInput /> */}
          <FloorForm.Tabs defaultTab={defaultTab} />
        </FloorForm>
      </FormOverlay>
    )
  }
)

FloorOverlay.displayName = "FloorOverlay"
